import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import DownloadApp from '@ivy/fts/inner/topBarOpenApp.vue';
import { isXcxWeb } from '@ivy/fts/utils';
import * as weixin from '@ivy/fts/weixin';
import openApp from '@ivy/fts/openApp';
let Index = class Index extends Vue {
    constructor() {
        super(...arguments);
        this.isXcxWeb = isXcxWeb();
        this.data = {};
    }
    get getStyle() {
        // return {
        //   background: 'url(' + this.data.pic_url + ') no-repeat left top',
        //   backgroundSize: '100% 263px',
        //   filter: 'blur(6px)',
        //   '-webkit-filter': 'blur(6px)',
        //   opacity: 0.3,
        // }
        return {};
    }
    get vipStyle() {
        return marker => {
            if (!marker) {
                return {};
            }
            else {
                return {
                    backgroundColor: marker.back_color,
                    color: marker.font_color,
                };
            }
        };
    }
    async created() {
        await this.getDetail();
        this.setShare();
    }
    async getDetail() {
        let data = await this.$axios.get('/api/audios/resource/pictureBook/getDetail', {
            params: {
                id: this.$route.query.id,
            },
        });
        this.data = data.data || {};
    }
    goOpenApp() {
        openApp('ivydadReadtool://detail/pictureBook?id=' + this.$route.query.id);
    }
    async setShare() {
        let options = {
            title: this.data.title,
            desc: this.data.content,
            imgUrl: this.data.pic_url,
            link: encodeURI(this.data.url || window.location.href),
        };
        await weixin.weixinShare(options);
    }
};
Index = tslib_1.__decorate([
    Component({
        components: {
            DownloadApp,
        },
    })
], Index);
export default Index;
